import { NgModule } from '@angular/core';
import { NoPreloading, PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { PRELOAD_MODULES } from './core/config/constants';
import { routerErrorHandler } from './core/factories/router-error-handler.factory';

const appRoutes: Routes = [
  { path: '', loadChildren: './dashboard/dashboard.module#DashboardModule' },
  { path: '404', component: NotFoundComponent },
  { path: 'preview', loadChildren: './pdf-preview/pdf-preview.module#PdfPreviewModule' },
];

const preloadingStrategy = (PRELOAD_MODULES) ? PreloadAllModules : NoPreloading;

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { errorHandler: routerErrorHandler , preloadingStrategy })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/app-routing.module.ts